var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExperiences = function SvgExperiences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.92 3.634a3.557 3.557 0 0 1 2.574 3.21l.006.198v9.896a3.567 3.567 0 0 1-3.373 3.557l-.19.005H6.053a2.576 2.576 0 0 1-2.568-2.41l-.005-.213.115-.098.24.033.239.016h.495l.099.099c0 .72.55 1.311 1.252 1.379l.133.006h10.885a2.378 2.378 0 0 0 2.37-2.212l.006-.163V7.042a2.376 2.376 0 0 0-1.267-2.098l-.159-.076-.059-.09v-.746l-.01-.094-.02-.164-.004-.036.125-.104zM13.968 1.5a2.576 2.576 0 0 1 2.567 2.41l.006.163v9.896a2.576 2.576 0 0 1-2.41 2.567l-.163.006H4.073a2.576 2.576 0 0 1-2.568-2.41l-.005-.163V4.073a2.576 2.576 0 0 1 2.41-2.568l.163-.005h9.896zm1.385 5.146H2.687v7.323c.001.72.55 1.31 1.253 1.379l.133.006h9.896c.72 0 1.31-.55 1.379-1.252l.006-.133V6.646zM13.97 2.687H6.646v2.771h8.708V4.073c0-.72-.55-1.311-1.252-1.379l-.133-.007zm-8.51 0H4.072c-.72.001-1.311.55-1.379 1.253l-.006.133v1.385h2.77v-2.77z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgExperiences;